import { MapPin } from 'lucide-react';
import { useCart } from '@/context/CartContext';

export default function LocationBanner({ onSetLocation }) {
  const { zone, orderType } = useCart();

  if (orderType === 'pickup' || zone) return null;

  return (
    <div data-testid="location-banner" className="sticky top-14 z-30 bg-[#E84C1C]/10 border-b border-[#E84C1C]/15 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <MapPin size={18} className="text-[#E84C1C] shrink-0" />
        <p className="flex-1 text-xs text-zinc-300 leading-tight">
          Elegí tu ubicación para calcular envío y habilitar el pedido
        </p>
        <button
          data-testid="location-banner-btn"
          onClick={onSetLocation}
          className="shrink-0 bg-[#E84C1C] text-white text-xs font-medium px-3.5 py-1.5 rounded-full hover:bg-[#d43f12] active:scale-95 transition-all"
        >
          Elegir ubicación
        </button>
      </div>
    </div>
  );
}
